import { AnimatePresence, motion } from "framer-motion";
import { FunctionComponent, ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import AnimatedOverlay from "@Components/atoms/AnimatedOverlay";
import "./style.scss";

interface Props {
  children: ReactNode;
  display: boolean;
  onDismiss: () => void;
}

const CartBottomSheet: FunctionComponent<Props> = ({ children, display, onDismiss }) => {
  const bottomSheetRoot = document.getElementById("bottomSheet-root");

  useEffect(() => {
    document.body.classList.toggle("noScroll", display);
  }, [display]);

  return ReactDOM.createPortal(
    <AnimatePresence>
      {display && (
        <motion.div>
          <AnimatedOverlay onClick={onDismiss} onFullPage={true} />
          <motion.div
            animate={{
              y: 0,
            }}
            className="CartBottomSheet"
            exit={{ y: "100%" }}
            initial={{ y: "100%" }}
            transition={{
              damping: 40,
              stiffness: 300,
              type: "spring",
            }}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    bottomSheetRoot || document.body
  );
};

export default CartBottomSheet;
